/**
 * An option that can be selected.
 */
export interface SelectOption {
  id: string
  text: string
}

/**
 * Whether 2 select options are considered equal.
 *
 * @param left
 * @param right
 */
export function areSelectOptionsEqual(
  left: SelectOption | undefined | null,
  right: SelectOption | undefined | null,
) {
  return left?.id === right?.id
}
